import React from "react";
import cover from '../asset/hero.jpeg'

const Hero = () => {
    return(
        <section className="bg-cover bg-center h-screen text-white"
        style={{ backgroundImage: `url(${cover})` }}
        >
            <div className="bg-color2 bg-opacity-60 h-full flex flex-col justify-center items-center text-center p-6">
                <h2 className="text-5xl font-bold mb-4">Hello...I'm Muhammad Rafa</h2>
                <p className="text-2xl mb-8">KiDi INTERN</p>
                <a href="#projects" className="bg-color3 opacity-100 hover:shadow-glow text-white font-bold py-2 px-6 rounded-lg transition duration-300 " >
                    My Projects
                </a>
            </div>
        </section>
    )
}

export default Hero;